import {
  Dashboard,
  FormatShapes,
  LocationOn,
  Description,
  StarsRounded,
  Pets,
  RememberMe,
  TipsAndUpdates,
  Quiz,
  CardGiftcard,
  Sick,
  EmojiEvents,
  ReceiptLong,
  AccountCircleRounded,
  School,
  PeopleOutlined,
  ManageAccounts,
  ContactSupport,
  Handshake,
} from "@mui/icons-material";

import StyleGuide from "../views/StyleGuide/StyleGuide";
import ClientList from "../views/ClientManagement/ClientList.container";
import RouteName from "./Route.name";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ClientCreate from "../views/ClientManagement/Create/ClientCreate";

import StateCreate from "../views/StateCity/Create/StateCreate.view";
import StateList from "../views/StateCity/StateList";
import CityList from "../views/StateCity/CityList";
import ProgramList from "../views/ProgramManagement/ProgramList";
import ProgramCreate from "../views/ProgramManagement/Create/ProgramCreate.view";
import ClientDetail from "../views/ClientManagement/Detail/ClientDetail";
import PopularCitiesList from "../views/PopularCities/PopularCitiesList";
import ProgramDetail from "../views/ProgramManagement/Detail/ProgramDetail";
import PetList from "../views/PetMaster/PetList";
import PetCreate from "../views/PetMaster/Create/PetCreate.view";
import AppUsersList from "../views/AppUsers/AppUsersList";
import AppUsersDetail from "../views/AppUsers/Detail/AppUsersDeatil";
import QuizCreate from "../views/Quiz/Create/QuizCreate.view";
import QuizDetail from "../views/Quiz/Detail/QuizDetail.view";
import QuizList from "../views/Quiz/List/QuizList";
import HealthTips from "../views/HealthTipsMaster/Create/HealthTips.view";
import HealthTipsList from "../views/HealthTipsMaster/HealthTipsList";
import HealthTipsDetail from "../views/HealthTipsMaster/Detail/HealthTipsDetail.view";
import SettingsIcon from "@mui/icons-material/Settings";
import AppSettingsContainer from "../views/AppSettings/AppSettings.container";
import AppSettings from "../views/AppSetting/AppSetting.view";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DoctorsList from "../views/DoctorMaster/DoctorList.container";
import RewardList from "../views/Reward/List/RewardList";
import RewardCreate from "../views/Reward/Create/RewardCreate.view";
import DashboardPage from "../views/dashboard/Dashboard";
import GiftStoreList from "../views/GiftsStore/List/GiftStoreList";
import GiftStoreCreate from "../views/GiftsStore/Create/GiftStoreCreate.view";
import GiftsStoreDetail from "../views/GiftsStore/Detail/GiftsStoreDetail.view";
import ReportedSideEffects from "../views/ReportedSideEffects/Detail/ReportedSideEffects.view";
import ReportedSideEffectsList from "../views/ReportedSideEffects/List/ReportedSideEffectsList";
import AuditTrialLog from "../views/AuditTrialLog/AuditTrialLog.view";
import AdminUsersDetail from "../views/AdminUsers/Detail/AdminUsersdetail.view";
import RoleDetail from "../views/Roles/Detail/RoleDetail";
import RoleCreate from "../views/Roles/RoleCreate";
import RolesList from "../views/Roles/List/RolesList";
import AdminUsersList from "../views/AdminUsers/List/AdminUsersList.view";
import Constants from "../config/constants";
import AdminUsersCreate from "../views/AdminUsers/Create/AdminUsersCreate.view";
import UserQueriesList from "../views/UserQueries/List/UserQueriesList.view";
import UserQueriesDetail from "../views/UserQueries/Detail/UserQueriesDetail.view";
import UserDashboard from "../views/UserDashboard/UserDashboard.view";
import ProgramDashboard from "../views/ProgramDashboard/ProgramDashboard.view";
import DoctorDashboard from "../views/DoctorDashboard/DoctorDashboard.view";
import DietList from "../views/Diet/List/DietList";
import DietCreate from "../views/Diet/Create/DietCreate.view";
import DietDeatil from "../views/Diet/Detail/DietDeatil";
import ShiftsLists from "../views/Shifts/Lists/ShiftsLists";
import ShiftDetail from "../views/Shifts/ShiftDetail/ShiftDetail";
import Welcome from "../views/Welcome/Welcome.view";

const dashboardRoutes = [
  // {
  //   path: "/",
  //   sidebarName: "Dashboard",
  //   icon: Dashboard,
  //   component: DashboardPage,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.STYLE_GUIDE}`,
  //   sidebarName: "Style Guide",
  //   icon: FormatShapes,
  //   component: StyleGuide,
  //   is_sidebar: true,
  // },
  {
    path: RouteName.PROGRAM,
    sidebarName: "Program Management",
    icon: Description,
    component: ProgramList,
    is_sidebar: true,
    module: Constants.MODULES.PROGRAM_MANAGEMENT,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.PROGRAM_CREATE,
  //   sidebarName: "Program Management",
  //   parentRoute: `${RouteName.PROGRAM}`,
  //   icon: Description,
  //   component: ProgramCreate,
  //   is_sidebar: false,
  //   module: Constants.MODULES.PROGRAM_MANAGEMENT,
  //   permissions: ['read', 'create', 'update']
  // },
  // {
  //   path: `${RouteName.PROGRAM_UPDATE}:id`,
  //   sidebarName: "Program Management",
  //   parentRoute: `${RouteName.PROGRAM}`,
  //   icon: Description,
  //   component: ProgramCreate,
  //   is_sidebar: false,
  // },
  {
    path: `${RouteName.PROGRAM_DETAIL}:id`,
    sidebarName: "Program Management",
    parentRoute: `${RouteName.PROGRAM}`,
    icon: Description,
    component: ProgramDetail,
    is_sidebar: false,
    module: Constants.MODULES.PROGRAM_MANAGEMENT,
    permissions: ["read"],
  },
  {
    path: RouteName.APP_USERS,
    sidebarName: "App Users",
    icon: RememberMe,
    component: AppUsersList,
    is_sidebar: true,
    module: Constants.MODULES.APP_USERS,
    permissions: ["read"],
  },
  {
    path: `${RouteName.APP_DETAIL}:id`,
    sidebarName: "App Users",
    parentRoute: `${RouteName.APP_USERS}`,
    icon: RememberMe,
    component: AppUsersDetail,
    is_sidebar: false,
    module: Constants.MODULES.APP_USERS,
    permissions: ["read"],
  },
  // {
  //   path: `${RouteName.CLIENT_MANAGEMENT}`,
  //   sidebarName: "Client Management",
  //   icon: GroupAddIcon,
  //   component: ClientList,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.CLIENT_CREATE}`,
  //   parentRoute: `${RouteName.CLIENT_MANAGEMENT}`,
  //   component: ClientCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.CLIENT_UPDATE}:id`,
  //   parentRoute: `${RouteName.CLIENT_MANAGEMENT}`,
  //   component: ClientCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.CLIENT_DETAIL}:id`,
  //   parentRoute: `${RouteName.CLIENT_MANAGEMENT}`,
  //   component: ClientDetail,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: RouteName.STATE_CITY,
  //   sidebarName: "State/City Master",
  //   icon: LocationOn,
  //   component: StateList,
  //   is_sidebar: true,
  // },
  // {
  //   path: `${RouteName.CITY}:id`,
  //   sidebarName: "State/City Master",
  //   parentRoute: `${RouteName.STATE_CITY}`,
  //   icon: LocationOn,
  //   component: CityList,
  //   is_sidebar: false,
  // },
  // {
  //   path: RouteName.POPULAR_CITIES,
  //   sidebarName: "Popular Cities",
  //   icon: StarsRounded,
  //   component: PopularCitiesList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.PET_MASTER,
  //   sidebarName: "Pet Master",
  //   icon: Pets,
  //   component: PetList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.PET_CREATE,
  //   sidebarName: "Pet Master",
  //   parentRoute: `${RouteName.PET_MASTER}`,
  //   icon: Pets,
  //   component: PetCreate,
  //   is_sidebar: false,

  // },
  // {
  //   path: `${RouteName.PET_UPDATE}:id`,
  //   sidebarName: "Pet Master",
  //   parentRoute: `${RouteName.PET_MASTER}`,
  //   icon: Pets,
  //   component: PetCreate,
  //   is_sidebar: false,
  // },
  {
    path: RouteName.ADMIN,
    sidebarName: "Client Users",
    icon: ManageAccounts,
    component: AdminUsersList,
    is_sidebar: true,
    // parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["read"],
  },
  {
    path: RouteName.ADMIN_CREATE,
    sidebarName: "Admin Users",
    parentRoute: `${RouteName.ADMIN}`,
    icon: ManageAccounts,
    component: AdminUsersCreate,
    is_sidebar: false,
    parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["create"],
  },
  {
    path: `${RouteName.ADMIN_UPDATE}:id`,
    sidebarName: "Admin Users",
    parentRoute: `${RouteName.ADMIN}`,
    icon: ManageAccounts,
    component: AdminUsersCreate,
    is_sidebar: false,
    parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["update"],
  },
  {
    path: `${RouteName.ADMIN_DETAIL}:id`,
    sidebarName: "Admin Users",
    parentRoute: `${RouteName.ADMIN}`,
    icon: ManageAccounts,
    component: AdminUsersDetail,
    is_sidebar: false,
    parent: "admin_users",
    module: Constants.MODULES.ADMIN_USERS,
    permissions: ["read"],
  },
  {
    path: RouteName.HEALTH_TIPS,
    sidebarName: "Health Tips Master",
    icon: TipsAndUpdates,
    component: HealthTipsList,
    is_sidebar: true,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["read"],
  },
  {
    path: RouteName.HEALTH_CREATE,
    sidebarName: "Health Tips Master",
    parentRoute: `${RouteName.HEALTH_TIPS}`,
    icon: TipsAndUpdates,
    component: HealthTips,
    is_sidebar: false,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["create"],
  },
  {
    path: `${RouteName.HEALTH_UPDATE}:id`,
    sidebarName: "Health Tips Master",
    parentRoute: `${RouteName.HEALTH_TIPS}`,
    icon: TipsAndUpdates,
    component: HealthTips,
    is_sidebar: false,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["update"],
  },
  {
    path: `${RouteName.HEALTH_DETAIL}:id`,
    sidebarName: "Health Tips Master",
    parentRoute: `${RouteName.HEALTH_TIPS}`,
    icon: TipsAndUpdates,
    component: HealthTipsDetail,
    is_sidebar: false,
    module: Constants.MODULES.HEALTH_TIPS_MASTER,
    permissions: ["read"],
  },
  {
    path: RouteName.QUIZ,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizList,
    is_sidebar: true,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.DIET,
  //   sidebarName: "Dietitian List",
  //   icon: Quiz,
  //   component: DietList,
  //   is_sidebar: true,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["read"],
  // },
  // {
  //   path: RouteName.DIET_CREATE,
  //   sidebarName: "Quiz",
  //   icon: Quiz,
  //   component: DietCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.DIET}`,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["create"],
  // },
  // {
  //   path: `${RouteName.DIET_DETAIL}:id`,
  //   sidebarName: "Quiz",
  //   icon: Quiz,
  //   component: DietDeatil,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.QUIZ}`,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["update"],
  // },
  // {
  //   path: RouteName.SHIFTS,
  //   sidebarName: "Shifts",
  //   navbarName: "Shifts",
  //   icon: PeopleOutlined,
  //   component: ShiftsLists,
  //   is_sidebar: true,
  //   is_protect: true,
  //   should_regex: true,
  //   // parent: "staff_manage",
  //   parentRoute: `${RouteName.QUIZ}`,
  //   module: Constants.MODULES.QUIZES_MODULE,
  //   permissions: ["update"],
  //   // roles: [Roles.ADMIN, Roles.CORPORATE_HR],
  // },
  // {
  //   path: `${RouteName.SHIFTS_DETAILS}:id`,
  //   navbarName: "Shifts",
  //   component: ShiftDetail,
  //   is_protect: true,
  //   should_regex: true,
  //   parent: "staff_manage",
  //   is_sidebar: false,
  //   // roles: [Roles.ADMIN, Roles.CORPORATE_HR],
  // },
  {
    path: RouteName.QUIZ_CREATE,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizCreate,
    is_sidebar: false,
    parentRoute: `${RouteName.QUIZ}`,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["create"],
  },
  {
    path: `${RouteName.QUIZ_UPDATE}:id`,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizCreate,
    is_sidebar: false,
    parentRoute: `${RouteName.QUIZ}`,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["update"],
  },
  {
    path: `${RouteName.QUIZ_DETAIL}:id`,
    sidebarName: "Quiz",
    icon: Quiz,
    component: QuizDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.QUIZ}`,
    module: Constants.MODULES.QUIZES_MODULE,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.REWARD,
  //   sidebarName: "Rewards Master",
  //   icon: EmojiEvents,
  //   component: RewardList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.REWARD_CREATE,
  //   sidebarName: "Quiz",
  //   icon: EmojiEvents,
  //   component: RewardCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.REWARD}`,
  // },
  // {
  //   path: `${RouteName.REWARD_UPDATE}:id`,
  //   sidebarName: "Quiz",
  //   icon: EmojiEvents,
  //   component: RewardCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.REWARD}`,
  // },
  // {
  //   path: RouteName.APP_SETTINGS,
  //   sidebarName: "App Settings",
  //   icon: SettingsIcon,
  //   component: AppSettings,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.DOCTOR_MASTER,
  //   sidebarName: "Doctor Master",
  //   icon: AddCircleIcon,
  //   component: DoctorsList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.GIFT,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftStoreList,
  //   is_sidebar: true,
  // },
  // {
  //   path: RouteName.GIFT_CREATE,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftStoreCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.GIFT}`,
  // },
  // {
  //   path: `${RouteName.GIFT_UPDATE}:id`,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftStoreCreate,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.GIFT}`,
  // },
  // {
  //   path: `${RouteName.GIFT_DETAIL}:id`,
  //   sidebarName: "Gifts Store",
  //   icon: CardGiftcard,
  //   component: GiftsStoreDetail,
  //   is_sidebar: false,
  //   parentRoute: `${RouteName.GIFT}`,
  // },
  {
    path: RouteName.DASHBOARD,
    sidebarName: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    is_sidebar: true,
    module: Constants.MODULES.DASHBOARD,
    permissions: ["read"],
  },
  // {
  //   path: RouteName.AUDIT_CREATE,
  //   sidebarName: "Audit Trail Log",
  //   icon: ReceiptLong,
  //   component: AuditTrialLog,
  //   is_sidebar: true,
  //   parentRoute: `${RouteName.AUDIT_CREATE}`,
  // },
  {
    path: RouteName.REPORTED,
    sidebarName: "Reported Side Effects",
    icon: Sick,
    component: ReportedSideEffectsList,
    is_sidebar: true,
    // module: Constants.MODULES.REPORTED_SIDE_EFFECTS,
    permissions: ["read"],
  },
  {
    path: `${RouteName.REPORTED_DETAIL}:id`,
    sidebarName: "Reported Side Effects",
    icon: Sick,
    component: ReportedSideEffects,
    is_sidebar: false,
    parentRoute: `${RouteName.REPORTED}`,
    // module: Constants.MODULES.REPORTED_SIDE_EFFECTS,
    permissions: ["read"],
  },
  {
    path: RouteName.USER_QUERIES,
    sidebarName: "User Queries",
    icon: ContactSupport,
    component: UserQueriesList,
    is_sidebar: true,
    module: Constants.MODULES.USER_PROGRAM_QUERIES,
    permissions: ['read']
  },
  {
    path: `${RouteName.USER_QUERIES_DETAIL}:id`,
    sidebarName: "User Queries",
    icon: ContactSupport,
    component: UserQueriesDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.USER_QUERIES}`,
  },
  {
    path: RouteName.USER_ENGAGEMENT_DASHBOARD,
    sidebarName: "User Engagement",
    icon: Handshake,
    component: UserDashboard,
    is_sidebar: true,
    module: Constants.MODULES.USER_ENGAGEMENT,
    permissions: ['read']
  },
  {
    path: RouteName.PROGRAM_DASHBOARD,
    sidebarName: "Program Adherence",
    icon: Dashboard,
    component: ProgramDashboard,
    is_sidebar: true,
    module: Constants.MODULES.PROGRAM_ADHERENCE,
    permissions: ["read"],
  },
  {
    path: RouteName.DOCTOR_DASHBOARD,
    sidebarName: "Doctor Performance",
    icon: Dashboard,
    component: DoctorDashboard,
    is_sidebar: true,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
  },
  // {
  //   path: "null",
  //   sidebarName: "Admin Users",
  //   navbarName: "Admin Users",
  //   icon: AccountCircleRounded,
  //   is_sidebar: true,
  //   slug: "admin_users",
  //   is_parent: true,
  // },
  // {
  //   path: `${RouteName.ROLES}`,
  //   sidebarName: "Roles",
  //   icon: School,
  //   component: RolesList,
  //   is_sidebar: true,
  //   parent: "admin_users",
  // },
  // {
  //   path: `${RouteName.ROLE_CREATE}`,
  //   parentRoute: `${RouteName.ROLES}`,
  //   component: RoleCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.ROLE_UPDATE}:id`,
  //   parentRoute: `${RouteName.ROLES}`,
  //   component: RoleCreate,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  // {
  //   path: `${RouteName.ROLE_DETAIL}:id`,
  //   parentRoute: `${RouteName.ROLES}`,
  //   component: RoleDetail,
  //   is_sidebar: false,
  //   is_protect: true,
  // },
    {
    path: `${RouteName.WELCOME}`,
    sidebarName: "Welcome",
    icon: ContactSupport,
    component: Welcome,
    is_sidebar: false,
    // module: Constants.MODULES.WELCOME,
    
  },
];

export default dashboardRoutes;
